export default __webpack_public_path__ + "media/zurb/img/icons/favicon/favicon-96x96-2130758d4a311ffb5b5f5dc313b63b50.png";